import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import AsyncPaginateBase from './async-paginate-base';
var AsyncPaginate = /*#__PURE__*/function (_Component) {
  _inherits(AsyncPaginate, _Component);
  var _super = _createSuper(AsyncPaginate);
  function AsyncPaginate(props) {
    var _this;
    _classCallCheck(this, AsyncPaginate);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onInputChange", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(inputValue) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.setState({
                  inputValue: inputValue
                });
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onMenuClose", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.setState({
                menuIsOpen: false
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _defineProperty(_assertThisInitialized(_this), "onMenuOpen", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.setState({
                menuIsOpen: true
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    _this.state = {
      inputValue: '',
      menuIsOpen: false
    };
    return _this;
  }
  _createClass(AsyncPaginate, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        inputValue = _this$state.inputValue,
        menuIsOpen = _this$state.menuIsOpen;
      return /*#__PURE__*/React.createElement(AsyncPaginateBase, _extends({}, this.props, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onInputChange: this.onInputChange,
        onMenuClose: this.onMenuClose,
        onMenuOpen: this.onMenuOpen
      }));
    }
  }]);
  return AsyncPaginate;
}(Component);
export default AsyncPaginate;